import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl bg-opacity-80 bg-blue-200" }, "Contributors", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5 mb-5" }, "We are thankful to our data collectors to take the time and contribute to the effort. ", -1)
const _hoisted_3 = { class: "m-1 table-auto text-m bg-opacity-40 bg-white mx-auto my-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-left px-2 pt-1" }, "Name"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-right px-2 pt-1" }, "Papers inspected")
], -1)
const _hoisted_5 = { class: "text-left px-2" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "text-right px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contributors, (contributor, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", _hoisted_5, [
            _createElementVNode("a", {
              href: 'http://github.com/' + contributor.entry
            }, _toDisplayString(contributor.entry), 9, _hoisted_6)
          ]),
          _createElementVNode("td", _hoisted_7, _toDisplayString(contributor.frequency), 1)
        ]))
      }), 128))
    ])
  ]))
}